import { useState } from 'react';
import { AppPage } from 'components/app-page/AppPage';
import CheckImport from '@pages/upload-pages/import-region-manager/CheckImport';
import UploadFile from '@pages/upload-pages/import-region-manager/UploadFile';



export const ImportRegionManager = () => {

	const [ allowImport, setAllowImport ] = useState(false);

	return (
		<AppPage
			className='upload-page'
			pageLabel='Nahrávání souborů - Region Manager'
		>
			<div className='upload-content'>	
				
				{allowImport === true &&
					<UploadFile uploadReset={() => setAllowImport(false)} />}

				{allowImport === false &&
					<CheckImport allowUpload={() => setAllowImport(true)}/>}

			</div>

		</AppPage>
	)
}

export default ImportRegionManager;